export default __webpack_public_path__ + "static/media/support-icon.f9253ffa.svg";